<template>
  <div class="goodModification"  :v-loading="loading">
       <el-table class="list" v-loading="loading"
                header-row-class-name="table-header"
                :ref="tableOptions.tableName"
                :data="tableData"
                @selection-change="handleSelectionChange"
                :header-row-style="{height:'28px',lineHeight:'28px'}"
                @row-click="rowClick" row-key="id"
                @select="rowSelect" @select-all="rowSelect"
      >
        <!--多选-->
        <el-table-column v-if="isSelect" type="selection" width="55"></el-table-column>
        <!--索引-->
        <el-table-column
          align="center"
          type="index"
          width="60"
          label="序号"
        ></el-table-column>
        <el-table-column
          v-for="(column,index) in (tableOptions.columns)"
          :key="index"
          :class-name="column.class"
          :property="column.prop"
          :label="column.label"
          :align="column.align ||tableOptions.align"
          :min-width="column.width || tableOptions.width"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
              <div v-show="scope.$index < tableData.length" :style="{height:'30px',lineHeight:'30px'}">
               <span v-if="column.type =='index'">{{ scope.$index + 1 }}</span>
               <el-input-number v-else-if="column.type == columnType.inputNumber"
                             @change="valueChange(column,scope.row,scope.$index)" :precision="column.precision||null"
                             v-model="scope.row[column.prop]" :min=0
                             :disabled="tableOptions.disabled"></el-input-number>
                <div v-else-if="column.enumData" v-html="$utils.getEnumItem(column,scope.row[column.prop])"></div>
                <span v-else>{{ scope.row[column.prop] }}</span>
              </div>
                <div v-show="scope.$index == tableData.length">
                     {{ scope.row[column.prop] }}
          </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <div class="fl total-cue">所有记录</div>
        <div class="fl total-cue">{{ page.total }}条</div>
        <!--分页-->
        <el-pagination
          class="tr"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.pageSize"
          :page-sizes="[10, 15, 20, 30, 40]"
          layout="prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>
</template>
<script>
import searchFormTemplate from '../template/searchFormTemplate';
import tableTemplate from '../template/tableTemplate';
import api from '@/config/api';

export default {
  props: {
    isSelect: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    tableOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    batchUpData: {
      type:Array,
      default: () => {
        return [];
      }
    },
    dataList: {
      type:Array,
      default: () => {
        return [];
      }
    },
        tableOptions: {
      type: Object,
      default: () => {
        return {
          tableName: "goodsTable",
          stripe: false, //是否斑马纹
          border: false, //是否带边框
          height: 500, //表格高度 单位px
          fixed: false, //string, boolean  true, left, right true 表示固定在左侧 表格左侧或右侧一列固定
          showSelect: false, // 是否显示选择框
          template: "", //自定义列模板 传入模板名称
          indexShow: false, //是否显示索引
          indexMethod: this.getIndex,
          columns: [
            { label: "ID", prop: "id", width: "100" },
            { label: "名称", prop: "name", width: "100" }
          ],
          url: "",
          param: {}
        };
      }
    },
  },
  components: {tableTemplate, searchFormTemplate},
  data() {
    return {
      columnType: this.$utils.columnType,
      loading: false,
      tableData: [],
      searchParam: {},
      page: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      tabelSelectRows: [],
      params: {}
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
     valueChange(column, row, index) {
      this.$forceUpdate();
      column.change && column.change(row, index);
    },
    selectSubmit() {
      this.clearSelection();
      this.$emit('selectSubmit', this.tabelSelectRows);
    },
    rowSelect(selection) {
      this.tabelSelectRows = selection;
    },
    searchClear() {
      this.searchParam = {};
      this.getTableData({});
    },
    searchSubmit(param) {
      this.getTableData(param);
    },
    rowClick(row, column, event) {
      if (this.isSelect) return;
      this.$emit('rowCheck', row);
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.current = 1;
      this.getTableData();
    },
    //清除选中
    clearSelection() {
      this.$refs[this.defaultTableOptions.tableName].clearSelection();
    },
    //选中项
    handleSelectionChange(val) {
      this.selectRow = val;
    },
    // 翻页
    handleCurrentChange(value) {
      this.page.current = value;
      this.getTableData();
    },
    // 获取表格数据
  getTableData() {
      let searchParam = {
        pageNumber: this.page.current,
        pageSize: this.page.pageSize
      };
      Object.assign(searchParam, this.tableOptions.param||{});
      Object.assign(searchParam, this.searchParam);
      this.loading = true;
      this.$axios.fetchPost(this.tableOptions.url + "/page", searchParam)
        .then(data => {
          this.loading = false;
          if (data.code == 200 && data.data) {
            this.tableData = data.data.records;
            this.page.total = data.data.total - this.dataList.length;
            if(this.dataList.length > 0){
                for(let i in this.dataList){
                  for(let k in this.tableData){
                    if(this.dataList[i].goodsId == this.tableData[k].id){
                       this.tableData.splice(k,1);
                      }
                  }
                }
            }
          } else {
            this.$message({ message: "请求失败！", type: "error" });
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({ message: "请求失败！", type: "error" });
          this.loading = false;
        });
    },
    getData(){
      return this.tableData;
    }
  }
}
</script>
<style scoped>
.pagination-box{
  margin-top: 10px;
  position: static;
}
.goodModification{
    height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/batchModification.vue